import _ from 'lodash';
import {
    FETCH_MTOKNA_MANUAL_CUSTOMER_ORDERS,
    CLEAN_MTOKNA_MANUAL_CUSTOMER_ORDERS,
    EDIT_MTOKNA_MANUAL_CUSTOMER_ORDER,
    DELETE_MTOKNA_MANUAL_CUSTOMER_ORDER,
    CHANGE_MTOKNA_MANUAL_CUSTOMER_ORDER_STATE,
    READY_PICKUP_MTOKNA_MANUAL_CUSTOMER_ORDER,
    PICKUP_MTOKNA_MANUAL_CUSTOMER_ORDER,
    ACTIVATE_MTOKNA_MANUAL_CUSTOMER_ORDER,
} from './types';
import {request, __, toNumber} from '../functions';

export const fetchMtoknaManualCustomerOrders = (screen, options = {}) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
        callback: null,
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request('/mtokna/customerOrders', params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        if (options.callback !== null) {
            // Zavolame callback
            options.callback();
        }

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_MTOKNA_MANUAL_CUSTOMER_ORDERS, payload: data });
    });
};

export const cleanMtoknaManualCustomerOrders = () => ({ type: CLEAN_MTOKNA_MANUAL_CUSTOMER_ORDERS });

/**
 * Zmazanie objednavky.
 *
 * @param {Screen} screen
 * @param {number} id
 */
export const deleteMtoknaManualCustomerOrder = (screen, id) => {
    return dispatch => request(`/mtokna/deleteManualCustomerOrder/${id}`, { order_delete_in_eshop: false }).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            // Objednavku sa nepodarilo zmazat
            screen.showSnackbar('error', __('Objednávku sa nepodarilo zmazať pretože má evidovanú faktúru'));
            return;
        }

        screen.showSnackbar('success', __('Objednávka bola zmazaná'));

        dispatch({ type: DELETE_MTOKNA_MANUAL_CUSTOMER_ORDER });
    });
};

export const changeMtoknaManualCustomerOrderState = (screen, id, stateId) => {
    return dispatch => request(`/mtokna/changeAdminCustomerOrderState/${id}/${stateId}`).then(response => {
        const { status, data } = response.data;

        if (status === 'error') {
            // Stav sa nepodarilo zmenit
            screen.showSnackbar('error', __('Stav objednávky sa nepodarilo zmeniť'));
            return;
        }

        screen.showSnackbar('success', __('Stav objednávky bol zmenený'));

        dispatch({ type: CHANGE_MTOKNA_MANUAL_CUSTOMER_ORDER_STATE, payload: { items: data, state: stateId } });
    });
};

export const readyPickupMtoknaManualCustomerOrder = (screen, id) => {
    return dispatch => request(`/mtokna/readyForPickupAdminCustomer/${id}`).then(response => {
        const { status, data } = response.data;

        if (status === 'error') {
            // Stav sa nepodarilo zmenit
            screen.showSnackbar('error', __('Nepodarilo sa zmeniť objednávku'));
            return;
        }

        screen.showSnackbar('success', __('Objednávka je pripravená na vyzdvihnutie'));

        dispatch({ type: READY_PICKUP_MTOKNA_MANUAL_CUSTOMER_ORDER, payload: { items: data, state: 'Pripravená na prevzatie' } });
    });
};

export const pickupMtoknaManualCustomerOrder = (screen, id) => {
    return dispatch => request(`/mtokna/pickupAdminCustomer/${id}`).then(response => {
        const { status, data } = response.data;

        if (status === 'error') {
            // Stav sa nepodarilo zmenit
            screen.showSnackbar('error', __('Nepodarilo sa zmeniť objednávku'));
            return;
        }

        screen.showSnackbar('success', __('Objednávka je vyzdvihnutá'));

        dispatch({ type: PICKUP_MTOKNA_MANUAL_CUSTOMER_ORDER, payload: { items: data, state: 'Doručená' } });
    });
};

export const activateMtoknaManualCustomerOrder = (screen, id) => {
    return dispatch => request(`/mtokna/activateAdminCustomer/${id}`).then(response => {
        const { status, data } = response.data;

        if (status === 'error') {
            // Stav sa nepodarilo zmenit
            screen.showSnackbar('error', __('Objednávku sa nepodarilo aktivovať'));
            return;
        }

        screen.showSnackbar('success', __('Objednávka bola aktivovaná'));

        dispatch({ type: ACTIVATE_MTOKNA_MANUAL_CUSTOMER_ORDER, payload: { items: data, state: 'Nová' } });
    });
};

export const changeMtoknaManualCustomerOrderData = (id, data) => ({ type: EDIT_MTOKNA_MANUAL_CUSTOMER_ORDER, payload: { id, data } });
